import { defineComponent as _defineComponent } from 'vue'
import { decode } from 'jsonwebtoken'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router/composables'

import LSkeleton from '@/components/core/Skeleton.vue'
import { useContext } from '@/composables/context'
import {
  useSetTokens,
  useAuthenticateWithGoogle,
  usePendingActions,
} from '@/composables/auth'
import { useMcpAuth } from '@/composables/mcp-auth'
import { eventModule, authModule } from '@/store'
import { SocialLoginType } from '@/utils/enums'
import { loadScript, logEvent } from '@/utils/utility-manager'

declare global {
  interface Window {
    google: typeof google
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleSignOnGoogle',
  props: {
    mode: null
  },
  setup(__props: any) {

const props = __props as {
  mode: 'sign_up' | 'sign_in'
};



const { i18n } = useContext()
const router = useRouter()

const { mutate: authenticateWithGoogle } = useAuthenticateWithGoogle()
const { setTokens } = useSetTokens()
const { handlePendingActions, getPendingActionsType } = usePendingActions()
const { completeMcpAuth } = useMcpAuth()

const googleSignInBtn = ref<HTMLDivElement>()
const isScriptLoaded = ref(false)

onMounted(() => {
  loadScript(
    'gsi-sdk',
    `https://accounts.google.com/gsi/client?hl=${i18n.locale}`,
    () => {
      if (!googleSignInBtn.value || !process.env.GOOGLE_CLIENT_ID) {
        return
      }
      isScriptLoaded.value = true

      window.google.accounts.id.initialize({
        client_id: process.env.GOOGLE_CLIENT_ID,
        callback: loginGoogle,
      })

      window.google.accounts.id.renderButton(googleSignInBtn.value, {
        theme: 'outline',
        size: 'large',
        locale: i18n.locale,
        text: 'continue_with',
        type: 'standard',
      })
    },
  )
})

function loginGoogle(authResponse: google.accounts.id.CredentialResponse) {
  if (!authResponse.credential) {
    return
  }
  try {
    const decodedToken = decode(authResponse.credential)
    if (!decodedToken || typeof decodedToken === 'string') {
      return
    }

    authenticateWithGoogle(
      {
        googleAccessToken: authResponse.credential,
        email: decodedToken.email,
        locale: i18n.locale as string,
        isDemo: authModule.loggedIn && authModule.user.isDemo,
      },
      {
        async onSuccess(response) {
          logEvent(
            props.mode === 'sign_in' ? 'logged_in' : 'registration_success',
            {
              method: 'google',
              onboarding_events: getPendingActionsType(),
            },
          )

          if (await completeMcpAuth(response)) return

          setTokens(response, SocialLoginType.GOOGLE)
          const redirectPath = await handlePendingActions()
          router.push({ path: redirectPath ?? '/' })
        },
      },
    )
  } catch (error) {
    eventModule.newError('error.login.google')
  }
}

return { __sfc: true,props, i18n, router, authenticateWithGoogle, setTokens, handlePendingActions, getPendingActionsType, completeMcpAuth, googleSignInBtn, isScriptLoaded, loginGoogle, LSkeleton }
}

})